import script from "./link.vue?vue&type=script&lang=tsx"
export * from "./link.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__